import { Component, Input, Output, EventEmitter } from '@angular/core';
import { getSingleWorkforcePersonEmail } from 'src/app/components/people-picker/people-picker.component';
import { WFWorker } from 'src/app/store/events.era';
import { ViewProfileDialogComponent } from '../workforce/workforce.dialog.viewProfile.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { MenuHoverButtonComponent } from 'src/app/components/buttons/menu-hover-button.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'manage-contact',
    template: `
<ng-container *ngIf="{ contact: workersByEmail[workforceContactEmail] } as vars">
  <add-manage-wrapper 
    [wrapperTitle]="'Workforce contact'"
    [titleIcon]="'WORKFORCE'"
    [hideHRule]="true"
    [readOnly]="readOnly"
    [openLabel]="readOnly ? '' : 'SELECT WORKFORCE CONTACT'" 
    (open)="manageWorkforceContact($event)" 
    >
    <div class="empty-text" *ngIf="!vars.contact">No workforce contact selected</div>
    <menu-hover-button 
      *ngIf="!!vars.contact" 
      [text]="vars.contact.firstName + ' ' + vars.contact.lastName" 
      [worker]="vars.contact"
      (click)="openContact(vars.contact)"
    ></menu-hover-button>
  </add-manage-wrapper>  
  <tip-text class="not-accepted" *ngIf="vars.contact && vars.contact.status !== 'accepted'" [type]="'warn'" [head]="'Attention:'" [body]="'This workforce member still needs to ' + ( vars.contact?.status === 'notInvited' ? 'be invited to and ' : '') + 'accept the event invitation to be the contact.'"></tip-text>
<ng-container>
`,
    styles: [`
  menu-hover-button { margin-bottom: 10px; display: block; }
  add-manage-wrapper { width: fit-content; }
  tip-text.not-accepted { margin-top: 10px; display: block; }
`],
    standalone: true,
    imports: [TipTextComponent, CommonModule, MenuHoverButtonComponent, AddManageWrapperComponent],
})

export class ManageContactComponent extends Wrapper<ManageContactComponent> {
  @Input() readOnly: boolean
  @Input() workforceContactEmail: string 
  workersByEmail: { [key: string]: WFWorker } = {}
  workforce: WFWorker[]

  @Output() changeContact: EventEmitter<string> = new EventEmitter()

  constructor() {
    super()
    this.subProp(this.store.select('workforce', 'workersByEmail'), 'workersByEmail')
    this.subProp(this.store.select('workforce', 'workforce'), 'workforce')
  }

  openContact(worker: WFWorker) {
    this.dialog.open(ViewProfileDialogComponent, { width: '480px', data: { worker, profileProvided: true }})
  }

  async manageWorkforceContact(event: Event) {
    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const contactEmail = await getSingleWorkforcePersonEmail(event, this.workforce, this.dialog, 'Choose workforce contact', false, this.workforceContactEmail, rect.left, rect.bottom - 10)
    if (!contactEmail) return 
    this.workforceContactEmail = contactEmail === this.workforceContactEmail ? null : contactEmail
    this.changeContact.emit(this.workforceContactEmail) // "deselecting" for this dialog returns the same thing clicked
  }
}


